import CityPageTemplate from "../city-template/CityPageTemplate";
import { raleighConfig } from "./data";

export default function RaleighPage() {
  return <CityPageTemplate config={raleighConfig} />;
}